// src/components/MagneticButton.tsx
// Butonun üstüne yaklaşınca hafifçe fareye doğru "çekilen" (mıknatıs efekti)
// ve etrafında yumuşak bir glow (parıltı) gösteren buton sarmalayıcı.
// Saf CSS/Framer Motion - WebGL yok, performans maliyeti neredeyse sıfır.
import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

interface MagneticButtonProps {
  children: React.ReactNode;
  className?: string;
  to?: string;
  href?: string;
  onClick?: () => void;
  target?: string;
  rel?: string;
}

const MagneticButton: React.FC<MagneticButtonProps> = ({
  children,
  className = "",
  to,
  href,
  onClick,
  target,
  rel,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const relX = e.clientX - (rect.left + rect.width / 2);
    const relY = e.clientY - (rect.top + rect.height / 2);
    setPos({ x: relX * 0.25, y: relY * 0.25 });
  };

  const handleMouseLeave = () => setPos({ x: 0, y: 0 });

  return (
    <motion.div
      ref={ref}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      animate={{ x: pos.x, y: pos.y }}
      transition={{ type: "spring", stiffness: 150, damping: 12, mass: 0.5 }}
      className="inline-block relative group"
    >
      <span className="absolute inset-0 rounded-lg bg-yellow-500/50 blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10" />
      {to ? (
        <Link to={to} onClick={onClick} className={className}>
          {children}
        </Link>
      ) : (
        <a href={href} onClick={onClick} target={target} rel={rel} className={className}>
          {children}
        </a>
      )}
    </motion.div>
  );
};

export default MagneticButton;
